import React from 'react'
import { observer } from 'mobx-react'
import BookkeepingProgressionViewModel, {
  BookkeepingStepInfo,
} from './BookkeepingProgressionViewModel'
import {
  Card,
  CardContentDescription,
  CardHeader,
  CardTitle,
  CardContent,
} from 'components/Card'
import Button from 'components/Button'
import ProgressBar from 'components/ProgressBar'
import Tooltip from 'components/Tooltip'
import Icon from 'components/Icon'

interface BookkeepingProgressionCardProps {
  vm: BookkeepingProgressionViewModel
}

export default observer(function BookkeepingProgressionCard({
  vm,
}: BookkeepingProgressionCardProps) {
  return (
    vm.bookkeepingStepInfo && (
      <Card>
        <BookkeepingProgressionCardContent
          bookkeepingStepInfo={vm.bookkeepingStepInfo}
        />
      </Card>
    )
  )
})

interface BookkeepingProgressionCardContentProps {
  bookkeepingStepInfo: BookkeepingStepInfo
}

const BookkeepingProgressionCardContent = observer(
  function BookkeepingProgressionCardContent({
    bookkeepingStepInfo,
  }: BookkeepingProgressionCardContentProps) {
    return (
      <>
        <CardHeader>
          <CardTitle>
            {bookkeepingStepInfo.title}&nbsp;
            {bookkeepingStepInfo.tooltip && (
              <Tooltip content={bookkeepingStepInfo.tooltip}>
                <Icon size={14} name="info-blue" color="var(--blue400)" />
              </Tooltip>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ProgressBar
            key={1}
            bars={[
              {
                progress: bookkeepingStepInfo.percentDone,
              },
              {
                progress: bookkeepingStepInfo.percentPending,
                style: 'striped',
              },
            ]}
          />
        </CardContent>
        <CardContent>
          <CardContentDescription>
            {bookkeepingStepInfo.description}
          </CardContentDescription>
        </CardContent>
        {bookkeepingStepInfo.secondaryAction && (
          <CardContent compactBottomPadding>
            <Button
              type="default"
              size="wide-slim"
              onClick={bookkeepingStepInfo.secondaryAction}
            >
              {bookkeepingStepInfo.secondaryActionText}
            </Button>
          </CardContent>
        )}
        {bookkeepingStepInfo.primaryAction && (
          <CardContent>
            <Button
              type="primary"
              onClick={bookkeepingStepInfo.primaryAction}
              size="wide-slim"
            >
              {bookkeepingStepInfo.primaryActionText}
            </Button>
          </CardContent>
        )}
      </>
    )
  },
)
